import React from 'react';
import { Col, Flex, Tooltip, message } from 'antd';
import { CopyOUtlined } from '@/assets/icons/icons';

type Props = {
  value?: string;
  span?: number;
  label?: string;
};

const formatSerialPreview = (serials: string) => {
  const list = serials
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

  if (list.length === 0) return '';
  if (list.length === 1) {
    const first = list[0];
    return first.length > 8 ? `${first.slice(0, 8)}...` : first;
  }

  const first = list[0];
  const firstFormatted = first.length > 8 ? `${first.slice(0, 8)}...` : first;

  return `${firstFormatted}, +${list.length - 1}`;
};

const InventorySerialsField: React.FC<Props> = ({
  value,
  span = 8,
  label = 'Serials',
}) => {
  if (!value) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    message.success('Serials copied!');
  };

  return (
    <Col xs={12} sm={12} md={span}>
      <Flex justify='center' vertical className='w-full group'>
        <Flex gap={4} align='center'>
          <span className='zl-heading-12'>{label}</span>

          <span className='copy-icon' onClick={handleCopy}>
            <CopyOUtlined />
          </span>
        </Flex>

        <Tooltip
          title={value}
          overlayInnerStyle={{
            maxWidth: 220,
            whiteSpace: 'normal',
          }}
        >
          <span
            className='zl-para-12 coc-comment-editor'
            style={{ fontSize: 13 }}
          >
            {formatSerialPreview(value)}
          </span>
        </Tooltip>
      </Flex>
    </Col>
  );
};

export default InventorySerialsField;
